import { render, staticRenderFns } from "./FaqSlider.vue?vue&type=template&id=04a62e3f&scoped=true&"
import script from "./FaqSlider.vue?vue&type=script&lang=js&"
export * from "./FaqSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a62e3f",
  null
  
)

export default component.exports